import { LoadingContainer } from 'peach/components'

import DynamicForm from 'core/components/lib/DynamicForm/DynamicForm'
import { Page, PageHeader } from 'core/components'
import { lineOfCreditLoanTypeSchema } from 'core/utils/generated/formSchemas'
import {
  LOCConfigurationData,
  useCompanyLoanConfigurationsAdd,
} from 'core/types'
import { defaultLineOfCreditLoanType } from './utils/defaultLoanType'
import { useHistory, useParams } from 'peach/router'

const CreateLineOfCreditLoanType = () => {
  const history = useHistory()
  const { companyId } = useParams<{ companyId?: string }>()

  const { mutateAsync: createLoanType } = useCompanyLoanConfigurationsAdd({
    companyId,
  })

  const onSubmit = async (
    data: LOCConfigurationData | Partial<LOCConfigurationData>,
  ) => {
    const res = await createLoanType(data as LOCConfigurationData)
    const createdId = (res.data as LOCConfigurationData)?.id
    if (createdId) {
      history.push(`/companies/${companyId}/loan-types/${createdId}`)
    }
  }

  return (
    <LoadingContainer>
      <Page variant='full'>
        <PageHeader title='Create Line of Credit Loan Type' />
        <DynamicForm
          data={defaultLineOfCreditLoanType}
          fieldEditMode='all'
          fieldOrder={['type', 'name', 'assetDisplayName', 'assetType']}
          omitFields={['id', 'createdAt', 'deletedAt', 'updatedAt']}
          onSubmit={onSubmit}
          schema={lineOfCreditLoanTypeSchema}
          submitText='Create Line of Credit Loan Type'
        />
      </Page>
    </LoadingContainer>
  )
}

export default CreateLineOfCreditLoanType
